import { InvestmentPlan } from './../../models/orders';
import { IRegistrationKiwiSaverEntityState } from './../../store/state/registration-kiwisaver.state';
import { filter, map } from 'rxjs/operators';
import { TradingFacades } from 'src/app/store/order/facades/trading.facades';
import { RegistrationKiwiSaverFacade } from './../../store/registration-kiwisaver/facade/kiwisaver-registration.facade';
import { Injectable } from '@angular/core';
import { zip, Observable, of } from 'rxjs';
import { TokenService } from '../token/token.service';
import { UserRoleType } from "src/app/models/userRoleTypes";
import { AuthService } from "../http/auth.service";
@Injectable()
export class KiwiSaverRedirectService {
    private kiwiSaverEntity$: Observable<any>;
    private investmentPlan$: Observable<Partial<InvestmentPlan>>;

    private isAdmin: boolean = false;
    private isAdvisor: boolean = false;

    constructor(
        private registrationKiwiSaverFacade: RegistrationKiwiSaverFacade,
        private tradingFacade: TradingFacades,
        private tokenService: TokenService,
        private authService: AuthService) {}

    private getRedirectParams$() {
        this.kiwiSaverEntity$ = this.registrationKiwiSaverFacade.getKiwisaverEntity().pipe(
            filter((entity) => entity != null),
            map((entity) => {
                return entity;
            })
        );
        this.investmentPlan$ = this.tradingFacade.getRegularInvestmentPlan().pipe(
            filter((ip) => ip != null),
            map((ip) => {
                return ip;
            })
        );
        return zip(
            this.kiwiSaverEntity$,
            this.investmentPlan$
        );
    }

    public getRedirectRoute$(clientSelected: boolean = false) {
        this.isAdmin = this.tokenService.isAdministrator();
        this.isAdvisor = this.authService.doesUserHaveRole(UserRoleType.Advisor);

        //If we're an advisor or administrator we dont need to have a KiwiSaver Entity with a Regular Investment Plan to load the application.
        //Still have a dependency on having a direct entity relationship to a KiwiSaver investor to access though.
        if ((this.isAdmin || this.isAdvisor)) {
            if (clientSelected) {
                return of('*');
            }
            else if(this.isAdvisor) {
                return of('/feature/overview');
            }
            else {
                return of('/feature/dashboard');
            }
        } 

        return this.getRedirectParams$().pipe(
            map((values: [IRegistrationKiwiSaverEntityState, InvestmentPlan]) => {
                const [kiwisaverEntity, investmentPlan] = values;
                const isEmptyInvestmentPlan = Object.keys(investmentPlan).length === 0 && investmentPlan.constructor === Object;

                if (!kiwisaverEntity.entityId && isEmptyInvestmentPlan) {
                    return '/register';
                } else if (kiwisaverEntity.entityId && isEmptyInvestmentPlan) {
                    return '/feature/client/buy-sell/regular-investment-plan';
                } else {
                    return '*'; // In case there is a kiwisaver entity and no empty investment plan return *, meaning the user doesn't have to be redirected anywhere
                }
            })
        );
    }
}
